import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { utilService } from '../../../../core/services'
import { Button, EditTableColumn } from '../../../atoms'
import { EditTable } from '../../../organisms'
import * as constants from '../../../../static/constants'
import * as interfaces from '../../../../static/interfaces'
import AdminLayoutIndex from '../_layouts'
import Typography from 'components/atoms/_layouts/Typography'

declare var window: interfaces.IWindow

interface IProps {
  tours: {
    tours: IJsonResponse
  }
  csv_path: string
}

const tour_group_options = { scope: 'activerecord.attributes.tour_group' }
const tour_options = { scope: 'activerecord.attributes.tour' }
const filterAndJoin = arr => arr.filter(d => d !== null && d !== undefined).join(', ')
const COLUMNS = [
  {
    name: `${I18n.t('id', tour_options)}`,
    field: 'ID',
    renderElement: (record: interfaces.ITours) => <EditTableColumn>{record.id}</EditTableColumn>,
  },
  {
    name: 'エージェント ID',
    field: 'agent_id',
    renderElement: (record: interfaces.ITours) => (
      <EditTableColumn>{record.post.user_id}</EditTableColumn>
    ),
  },
  {
    name: `${I18n.t('id', tour_group_options)}`,
    field: 'tour_group_id',
    renderElement: (record: interfaces.ITours) => (
      <EditTableColumn>{filterAndJoin(record.tour_groups.map(({ id }) => id))}</EditTableColumn>
    ),
  },
  {
    name: 'ゲスト ID',
    field: 'guest_id',
    renderElement: (record: interfaces.ITours) => (
      <EditTableColumn>
        <div>
          <div style={{ display: 'flex' }}>
            <Typography color="subtext">assigned: </Typography>
            {filterAndJoin(
              record.tour_groups.map(t =>
                filterAndJoin(
                  t.tour_reservations.map(({ reservable }) => reservable.user?.id ?? 'direct')
                )
              )
            )}
          </div>
          <div style={{ display: 'flex' }}>
            <Typography color="subtext">unassigned: </Typography>
            {filterAndJoin(
              record.unassigned_tour_reservations.map(
                ({ reservable }) => reservable.user?.id ?? 'direct'
              )
            )}
          </div>
        </div>
      </EditTableColumn>
    ),
  },
  {
    name: 'ガイド ID',
    field: 'guide_id',
    renderElement: (record: interfaces.ITours) => (
      <EditTableColumn>{filterAndJoin(record.tour_groups.map(t => t.guide?.id))}</EditTableColumn>
    ),
  },
  {
    name: '催行日時',
    field: 'day',
    renderElement: (record: interfaces.ITours) => (
      <EditTableColumn>
        {record.day} {record.start_time}
      </EditTableColumn>
    ),
  },
  {
    name: 'ゲスト支払い金額合計',
    field: 'price',
    renderElement: (record: interfaces.ITours) => (
      <EditTableColumn>
        {record.tour_groups.reduce(
          (p, t) => p + t.tour_reservations.reduce((_p, r) => _p + r.reservable.price, 0),
          0
        )}
      </EditTableColumn>
    ),
  },
  {
    name: 'プラットフォーム手数料',
    field: 'platform_fee',
    renderElement: (record: interfaces.ITours) => (
      <EditTableColumn>
        {Math.round(
          record.tour_groups.reduce(
            (p, t) => p + t.tour_reservations.reduce((_p, r) => _p + r.reservable.price, 0),
            0
          ) / 5
        )}
      </EditTableColumn>
    ),
  },
  {
    name: 'エージェント申請の経費',
    field: 'cost',
    renderElement: (record: interfaces.ITours) => {
      const total = record.tour_groups.reduce(
        (p, t) => {
          return {
            reimbursable_cost: p.reimbursable_cost + t.reimbursable_cost,
            subcontract_cost: p.subcontract_cost + t.subcontract_cost,
            tour_cost: p.tour_cost + t.tour_cost,
          }
        },
        {
          reimbursable_cost: 0,
          subcontract_cost: 0,
          tour_cost: 0,
        }
      )

      return (
        <EditTableColumn>
          {
            <div>
              <div style={{ display: 'flex' }}>
                <Typography color="subtext">立替費: </Typography> {total.reimbursable_cost}
              </div>
              <div style={{ display: 'flex' }}>
                <Typography color="subtext">外注費: </Typography> {total.subcontract_cost}
              </div>
              <div style={{ display: 'flex' }}>
                <Typography color="subtext">手数料: </Typography> {total.tour_cost}
              </div>
            </div>
          }
        </EditTableColumn>
      )
    },
  },
]

const Index: React.FC<IProps> = props => {
  const {
    data: tours,
  }: {
    data: interfaces.ITours[]
  } = utilService.getDataFromJson(props.tours.tours)
  const [meta, setMeta] = React.useState(props.tours.tours.meta)

  const records = tours

  return (
    <AdminLayoutIndex
      model="tours"
      title={
        <Heading>
          <span>{I18n.t('generic.tour_groups')}</span>
          {props.csv_path && (
            <Button small={true}>
              <a href={props.csv_path}>{I18n.t('generic.csv') + I18n.t('generic.download')}</a>
            </Button>
          )}
        </Heading>
      }
      main={<EditTable editable={false} columns={COLUMNS} records={records} pagination={meta} />}
    />
  )
}

const Heading = styled.div`
  .Button {
    margin-left: 12px;
  }
`

const Wrapper = styled.div`
  max-width: 1200px;
  margin: auto;

  .Sammary_Top {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 60px;
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      margin-top: 40px;
    }
  }
  .Sammary_Bottom {
    max-width: 570px;
    margin: 40px auto;
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      margin: 40px auto;
    }
  }
  .Table_Section {
    margin: 80px auto 0;
  }
`
const TitleWithButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Amount = styled.div`
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  margin-left: 50px;
  @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
    margin-left: 20px;
  }
  .Amount_Date {
    color: ${constants.COLORS.subText};
    font-size: 28px;
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      font-size: 18px;
    }
  }
  .Amount_Current {
    font-size: 80px;
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      font-size: 40px;
    }
  }
  .Amount_Diff {
    font-size: 22px;
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      font-size: 16px;
    }
    .Diff_Date {
      color: ${constants.COLORS.subText};
    }
    .Diff_Price {
      &.up {
        color: ${constants.COLORS.successText};
      }
      &.flat {
        color: ${constants.COLORS.useallyText};
      }
      &.down {
        color: ${constants.COLORS.cautionText};
      }
    }
  }
`

export default Index
